import { gql } from 'graphql-request';

export const SEND_TO_CORRECT_CONTROL_CARD = gql`
  mutation App5182dd71_Document($documentId: String!) {
    app5182dd71_ControlCard {
      sendToCorrect(documentId: $documentId) {
        status
        message {
          ru
          en
        }
      }
    }
  }
`;
